(() => {
  if (window.__twBundleLoaderInit) return;
  window.__twBundleLoaderInit = true;
  sessionStorage.setItem('tw-bundle-seen', '1');

  const current = document.currentScript?.src;
  if (!current) return;
  const assetUrl = (name) => new URL(name, current).href;

  const css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = assetUrl('tawerna-bundle-v2.css');
  document.head.appendChild(css);

  const data = document.createElement('script');
  data.src = assetUrl('tawerna-bundle-v2-data.js');
  data.defer = true;
  data.onload = () => {
    const logic = document.createElement('script');
    logic.src = assetUrl('tawerna-bundle-v2.js');
    logic.defer = true;
    document.head.appendChild(logic);
  };
  document.head.appendChild(data);
})();
